class Conversations
    constructor: (el) ->
        @.$el = el
        @.$backButton = @.$el.querySelector '.conversations__thread__head__back'
        @.$conversationsElements = @.$el.querySelectorAll '.conversations__list__conversation'
        @.$conversationPartnerEl = @.$el.querySelector '.conversations__thread__user span'
        @.$conversationsThreadEl = @.$el.querySelector '.conversations__thread'
        @.$errorTextEl = @.$el.querySelector '.conversations__thread__error__text'
        @.$loader = @.$el.querySelector '.conversations__thread__loader'
        @.$loadOlderButton = @.$el.querySelector '.conversations__load-older'
        @.$messagesEl = @.$el.querySelector '.conversations__thread__messages'

        @.activeConversation = false
        @.amount = @.$el.dataset?.amount ? 10
        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? false
        @.conversations = false
        @.shownMessages = @.$el.dataset
        @.userId = @.$el.dataset?.userId ? false
        @.username = @.$el.dataset?.username ? false
        @.userPic = @.$el.dataset?.userPic ? false

        @.$el.classList.add 'conversations--bound'
        @.SetLoaderState true
        if @.$conversationsElements.length < 1
            @.SetLoaderState false
            @.SetNothingFound true
        else   
            if @.api
                @.GetData()
                @.InitEvents()
            else
                @.SetErrorState true
        return
    
    AddToConversations: (results) ->
        self = @
        if !@.conversations
            @.conversations = results
        else
            Object.keys(results).forEach (uid) ->
                if self.conversations[uid]
                    self.conversations[uid].messages.push ...results[uid].messages
                else
                    self.conversations[uid] = results[uid]
                return
        return
    
    ClearMessages: ->
        @.$messagesEl.innerHTML = ""
        @.$conversationsThreadEl.classList.remove 'conversations__thread--active'
        return
    
    CreateSpeechBubble: (date, text, username, own) ->
        return window.CreateSpeechBubble {
            color: if own then false else 'purple'
            date: date
            own: own
            textContent: text
            username: username
        }
    
    GetConversation: (partnerUserId) ->
        if partnerUserId && @.conversations["uid_#{ partnerUserId }"]
            @.SetLoadMoreState @.conversations["uid_#{ partnerUserId}"].messages.length < @.conversations["uid_#{ partnerUserId }"].totalMessages
            @.$conversationPartnerEl.textContent = @.conversations["uid_#{ partnerUserId }"].username
            @.$conversationsThreadEl.classList.add 'conversations__thread--active'
            return @.conversations["uid_#{ partnerUserId }"]
        return false

    GetData: (partnerUserId) ->
        if @.apiMethod == 'GET' || @.apiMethod == 'POST'
            self = @
            try
                if @.apiMethod == 'POST'
                    body = {
                        amount: @.amount
                        offset: @.shownElements
                        partnerUserId: partnerUserId ? false
                        userId: @.userId
                    }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                                self.AddToConversations answer.results
                                self.SetLoaderState false
                                self.SetChooseState !self.activeConversation
                                if partnerUserId
                                    self.ClearMessages()
                                    self.PrependMessages self.GetConversation(partnerUserId)
                            catch error
                                errorText = "Fehler beim Versuch die Datenquelle für Nachrichten zu verarbeiten"
                                console.log errorText
                                self.SetErrorState true, errorText
                                return
                        else
                            console.log "Die Anfrage der Datenquelle für Nachrichten lieferte ein leeres Ergebnis"
                            if !partnerUserId
                                self.SetNothingFoundState true
                    , ->
                        errorText = "Bei der Anfrage an die Datenquelle für Nachrichten ist leider ein Fehler aufgetreten"
                        console.log errorText
                        self.SetErrorState true, errorText
                        return
                    , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
            catch error
                errorText = "Fehler beim Versuch die Datenquelle für Nachrichten zu ermitteln"
                console.log errorText
                self.SetErrorState true, errorText
        else
            try
                if window[@.api]
                    @.conversations = window[@.api]
                    @.SetLoaderState false
                else
                    console.log "Fehler beim Versuch die Datenquelle für Nachrichten zu ermitteln"
                    @.SetErrorState true
            catch error
                console.log "Fehler beim Versuch die Datenquelle für Nachrichten zu verarbeiten"
                @.SetErrorState true
        return

    InitEvents: ->
        self = @
        @.$conversationsElements.forEach (conversationEl) ->
            conversationEl.addEventListener 'click', (e) ->
                e.preventDefault()
                self.activeConversation = true
                self.SetChooseState false
                activeElement = self.$el.querySelector '.conversations__list__conversation--active'
                if activeElement
                    activeElement.classList.remove 'conversations__list__conversation--active'
                @.classList.add 'conversations__list__conversation--active'
                self.ClearMessages()
                self.PrependMessages self.GetConversation(@.dataset?.userId ? false)
                return
        @.$loadOlderButton.addEventListener 'click', (e) ->
            self.api = './Api/conversionsUpdate.json'
            self.GetData("2")
            return
        @.$backButton.addEventListener 'click', (e) ->
            e.preventDefault()
            activeElement = self.$el.querySelector '.conversations__list__conversation--active'
            if activeElement
                activeElement.classList.remove 'conversations__list__conversation--active'
            self.ClearMessages()
            self.SetChooseState true
            self.activeConversation = false
            return
        return
    
    PrependMessages: (conversation) ->
        self = @
        if conversation
            if conversation.messages && conversation.messages.length > 0
                conversation.messages.forEach (message) ->
                    speechBubble = self.CreateSpeechBubble message.date, message.text, (if message.own then self.username else conversation.username), message.own
                    if speechBubble
                        messageEl = document.createElement 'div'
                        messageEl.classList.add 'conversations__thread__message'
                        if message.own
                            messageEl.classList.add 'conversations__thread__message--own'
                        messageEl.appendChild window.CreateProfilePic {
                            attrs: {
                                class: ['conversations__thread__message__pic']
                            }
                            onWhite: true
                            pic: if message.own then self.userPic else conversation.userPic
                            small: true
                        }
                        messageEl.appendChild speechBubble
                        self.$messagesEl.prepend messageEl
                    return
        return
    
    SetErrorState: (activeError, errorText) ->
        if activeError
            @.$el.classList.add 'conversations--error'
            @.SetLoaderState false
            @.ClearMessages()
            if errorText && errorText != ''
                @.$errorTextEl.textContent = errorText
        else
            @.$el.classList.remove 'conversations--error'
        return

    SetChooseState: (show) ->
        if show
            @.$el.classList.add 'conversations--choose'
            @.SetLoaderState false
        else
            @.$el.classList.remove 'conversations--choose'
        return
    
    SetLoadMoreState: (show) ->
        if show
            @.$loadOlderButton.classList.add 'conversations__load-older--shown'
        else
            @.$loadOlderButton.classList.remove 'conversations__load-older--shown'
        return
    
    SetLoaderState: (show) ->
        if show
            @.$loader.dispatchEvent new CustomEvent 'loader-show', {bubbles: false}
            @.ClearMessages()
        else
            @.$loader.dispatchEvent new CustomEvent 'loader-hide', {bubbles: false}
        return

    SetNothingFoundState: (noResults) ->
        if noResults
            @.$el.classList.add 'conversations--nothing-found'
            @.SetLoaderState false
            @.ClearMessages()
        else
            @.$el.classList.remove 'conversations--nothing-found'
        return

BindConversations = ->
    document.querySelectorAll '.conversations:not(.conversations--bound)'
        .forEach (el) ->
            new Conversations el
            return
    return

window.addEventListener 'bind-components', BindConversations